module.exports = {
  headers: {
    accept: 'application/json'
  },
  // baseUrl: 'https://localhost:44393/api/',
  baseUrl: 'https://organizador.corujasapp.com/api/',
  // baseUrl: 'https://staging.corujasapp.com/api/',
  pagarmePublicKey: 'pk_Xgzp2VehbguMBpGj',
}
